<template>
    <div class="content content-page bookmark">
        <div class="container">
            <div class="row">

                <projectsidebarpostulante></projectsidebarpostulante>

                <div class="col-xl-9 col-lg-9">
                    <div class="dashboard-sec payout-section freelancer-statements">
                        <div class="page-title portfolio-title text-center onboard-head">
                            <h3 style="margin:auto;">Ofertas Laborales</h3>
                        </div>

                        <!-- Table -->
                        <div class="table-top-section">
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-agv-dos"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    data-bs-toggle="dropdown"
                                    style="border-radius: 3px; padding: 12px;width: 120px"
                                    >
                                <i class="fa fa-filter"></i>
                                    Filtros
                                </button>
                                <div class="dropdown-menu" style="width: 280px;">
                                    <div class="card search-filter">
                                        <div class="card-header d-flex justify-content-between">
                                            <h4 class="card-title mb-0 text-white" style="font-size:17px">Seleccionar:</h4>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="filter-widget" style="margin-top: -35px;">
                                            <h4 class="filter-title">
                                                <a href="javascript:void(0);" class="w-100" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                  Periodo
                                                  <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                                                </a>
                                            </h4>
                                            <div id="collapseOne" class="collapse show" data-bs-parent="#accordionExample1" >
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_period" value="fijo">
                                                        <span class="checkmark"></span> Fijo
                                                    </label>
                                                </div>
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_period" value="eventual">
                                                        <span class="checkmark"></span> Eventual
                                                    </label>
                                                </div>
                                            </div>
                                            <h4 class="filter-title">
                                                <a href="javascript:void(0);" class="w-100" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Puesto	
                                                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                                                </a> 
                                            </h4>
                                            <div id="collapseOne" class="collapse show" data-bs-parent="#accordionExample1" >
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_positions" value="auxiliar">
                                                        <span class="checkmark"></span> Auxiliar
                                                    </label>
                                                </div>
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_positions" value="asistente">
                                                        <span class="checkmark"></span> Asistente
                                                    </label>
                                                </div>
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_positions" value="analista">
                                                        <span class="checkmark"></span> Analista
                                                    </label>
                                                </div>
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_positions" value="supervisor">
                                                        <span class="checkmark"></span> Supervisor
                                                    </label>
                                                </div>
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_positions" value="coordinador">
                                                        <span class="checkmark"></span> Coordinador
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="filter-widget" style="margin-top: -15px;">
                                            <h4 class="filter-title">
                                                <a href="javascript:void(0);" class="w-100" data-bs-toggle="collapse" data-bs-target="#collapseskills" aria-expanded="true" aria-controls="collapseOne">
                                                    Lugar
                                                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                                                </a> 
                                            </h4>
                                            <div id="collapseskills" class="collapse show" data-bs-parent="#accordionExample1" >
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time"  v-model="selected_places" value="Lima">
                                                        <span class="checkmark"></span> Lima
                                                    </label>
                                                </div>
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_places" value="Chiclayo">
                                                        <span class="checkmark"></span> Chiclayo	
                                                    </label>
                                                </div>
                                                <div @click.stop>
                                                    <label class="custom_check">
                                                        <input type="checkbox" name="select_time" v-model="selected_places" value="Olmos">
                                                        <span class="checkmark"></span> Olmos
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <button type="button" class="btn btn-agv-dos" style="width:100%;border-radius:5px;font-size:14px;text-align:center" @click="localFilter">Buscar</button>
                                            </div>
                                            <div class="col-md-6">
                                                <button type="button" class="btn btn-block" style="width:100%;border-radius:5px;font-size:14px;text-align:center"  @click="clearFilters">Limpiar</button>
                                            </div>
                                        </div>	
                                    </div>
                                </div>
                            </div>

                            <div class="table-options">
                                <div class="data-search-input">
                                    <input type="text" class="form-control" placeholder="Buscar por palabra clave" name="search" id="search" v-model="search_query" @input="searchOffers">
                                </div>
                            </div>

                        </div>

                        <!-- Page Content -->
                        <div class="content" style="margin-top: -60px">
                            <div class="container">
                                <div class="row">                        
                                <div>
                                    <div class="row">
                                        <!-- Project Content -->
                                        <div
                                            class="col-xl-4 col-md-6"
                                            v-for="record in filtered_job_offers"
                                            :key="record.id"
                                        >
                                            <div class="freelance-widget widget-author position-relative">
                                            <div class="freelance-content">
                                                <div class="freelance-location freelance-time" >
                                                <i class="feather-clock me-1"></i> Publicado {{ record.created_date }}
                                                </div>
                                                <!-- <a data-bs-toggle="modal" href="#rating" class="favourite"
                                                ><i class="feather-heart"></i
                                                ></a> -->
                                                <div class="author-heading">
                                                <div class="freelance-img">
                                                    <a href="javascript:void(0);">
                                                    <!-- <img
                                                        :src="require(`@/assets/img/company/${record.Image}`)"
                                                        alt="author"
                                                    /> -->
                                                    <img 
                                                    v-if="record.s3_url" 
                                                    :src="record.s3_url" 
                                                    class="img-fluid" 
                                                    style="width: 100%;"
                                                    >
                                                    <img
                                                    v-if="!record.s3_url"
                                                    :src="require(`@/assets/img/agv_logo.jpg`)"
                                                    alt="author"
                                                    />
                                                    <span class="verified"><i class="fas fa-check-circle"></i></span>
                                                    </a>
                                                </div>
                                                <div class="profile-name" style="height: 80px; margin-bottom: 50px;">
                                                    <div class="author-location">{{ record.work_pos }}</div>
                                                </div>
                                                <div class="freelance-info">
                                                    <!-- <h3>
                                                    <a href="javascript:void(0);">{{ record.Ui }}</a>
                                                    </h3> -->
                                                    <div class="freelance-location">
                                                    <img
                                                        :src="require(`@/assets/img/icon/locations.svg`)"
                                                        alt="img"
                                                        style="margin-right: 5px;"
                                                    />{{ record.place }}
                                                    </div>
                                                </div>
                                                <div class="freelance-tags">
                                                    <!-- <a href="javascript:void(0);"
                                                    ><span class="badge badge-pill badge-design me-1">{{
                                                        record.Html
                                                    }}</span></a
                                                    >
                                                    <a href="javascript:void(0);"
                                                    ><span class="badge badge-pill badge-design me-1">{{
                                                        record.React
                                                    }}</span></a
                                                    > -->
                                                    <a href="javascript:void(0);"
                                                    ><span class="badge badge-pill badge-design me-1">{{
                                                        record.n_vacancy
                                                    }} vacantes</span></a
                                                    >
                                                </div>
                                                </div>
                                            </div>
                                            <div class="cart-hover">
                                                <router-link 
                                                :to="{ path: '/dashboard_detalle_oferta', query: { id: record.id } }" 
                                                class="btn-cart" 
                                                tabindex="-1"
                                                >
                                                <!-- to="/detalle_oferta"  -->
                                                Ver más
                                                </router-link
                                                >
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>

<script>
import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
export default {
props: {
  offerId: {
    type: Number,
    required: true
  }
},

data() {
    return {
        filtered_job_offers: [],
        all_job_offers: [],
        selected_positions: [], 
        selected_places: [],
        selected_period: [],

        isDropdownOpen: false,
        offerId:null,
        search_query: '',
    };

},
mounted(){
  this.getJobOffers();
},
watch: {
search_query() {
    this.searchOffers();
},
// selected_positions() {
//     this.localFilter();
// },
// selected_places() {
//     this.localFilter();
// }
},
methods: {
    getJobOffers(){
        const yo = this
        const config = {
            method: 'get',
            url: '/talentoagv/readJobOffers/',
        }

        if(this.$store.getters.currentAdminLanguage == 'es'){
            yo.language = '1'
        }
        else if(this.$store.getters.currentAdminLanguage == 'en'){
            yo.language = '2'
        }

        axiosIns(config)
            .then(function (response) {
                // console.log(response.data['result'])
                if (response.data['is_error'] === false){
                    let resultado = response.data['result']
                    for(let r of resultado){
                        let fullName = r['name'] + ' ' + r['first_surname'] + ' ' + r['second_surname'];
                        r['fullname'] = fullName;
                    }
                    yo.filtered_job_offers = resultado
                    yo.all_job_offers = resultado
                }
            })
            .catch(function (error) {
              // console.log(error);
              yo.$toastr.error(response.data['message'], 'Error')
            })
            .finally(function (){
            
            })
    },

    localFilter(){
        this.filtered_job_offers = this.all_job_offers.filter(offer => {
            const matchesWorkPos = this.selected_positions.length === 0 || this.selected_positions.some(pos => offer.work_pos.toLowerCase().includes(pos.toLowerCase()));
            const matchesPlace = this.selected_places.length === 0 || this.selected_places.some(place => offer.place.toLowerCase().includes(place.toLowerCase()));
            const matchesPeriod = this.selected_period.length === 0 || this.selected_period.some(period => offer.period.toLowerCase().includes(period.toLowerCase()));
            return matchesWorkPos && matchesPlace && matchesPeriod;
        });
    },

    clearFilters() {
        this.selected_positions = [];
        this.selected_places = [];
        this.selected_period = []
        this.filtered_job_offers = this.all_job_offers;
    },

    searchOffers() {
      const query = this.search_query.toLowerCase();
      this.filtered_job_offers = this.all_job_offers.filter(offer => {
        return (this.selected_positions.length === 0 || this.selected_positions.some(pos => offer.work_pos.toLowerCase().includes(pos.toLowerCase())))
            && (this.selected_places.length === 0 || this.selected_places.some(place => offer.place.toLowerCase().includes(place.toLowerCase())))
            && (this.selected_period.length === 0 || this.selected_period.some(period => offer.period.toLowerCase().includes(period.toLowerCase())))
          && (offer.work_pos.toLowerCase().includes(query) || offer.place.toLowerCase().includes(query));
      });
    },
},

};


</script>
